export const UserMessages = {
  customCallerIdDescription: "Customer Outbound caller Id is not authenticated, would like to authenticate? Press Yes to get verification code",
  twilioVerificationCodeMessage: "Twilio Verification Code:",
  callerIdVerified: "caller Id is already verified",
  phoneNumberVerified: "Phone number is already verified.",
  blankPhoneNumber: "No Phone number is added for Authentication.",
};
